(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/betslip-systeminfo.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/betslip-systeminfo.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.BetslipSysteminfo = Backbone.Marionette.View.extend({
    tagName: 'div',
    className: svs.core.detect.feature('ft-betslip')
      ? 'panel-betslip'
      : 'panel panel-betslip',
    modelEvents: {
      change: 'render'
    },

    template: function(data) {
      return svs.tipset.templates.betslipsysteminfo(data);
    }
  });
})(Backbone, _, svs);

 })(window);